import React, { useState, useEffect } from "react";
import { Form, Button, Dropdown } from "react-bootstrap";
import TypeTreeDropdown from "./TypeTreeDropdown";

const calcDateFromByPeriod = (period) => {
  const today = new Date();
  const d = new Date(today);

  switch (period) {
    case "6m":
      d.setMonth(d.getMonth() - 6);
      break;
    case "1y":
      d.setFullYear(d.getFullYear() - 1);
      break;
    case "18m":
      d.setMonth(d.getMonth() - 18);
      break;
    case "2y":
      d.setFullYear(d.getFullYear() - 2);
      break;
    case "3y":
      d.setFullYear(d.getFullYear() - 3);
      break;
    default:
      return "";
  }

  return d.toISOString().slice(0, 10); // YYYY-MM-DD
};

const FilterBar = ({ visibleFilters=[], onApply, defaultValues = {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [filters, setFilters] = useState({
    search: "",
    type: "",
    dateFrom: "",
    dateTo: "",
    sort: "",
    ...defaultValues,
  });

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      search: "",
      type: "",
      dateFrom: "",
      dateTo: "",
      sort: "",
      ...defaultValues,
    }));
  }, [defaultValues]);  

  const isFiltersClean = () =>
    !filters.search &&
    !filters.type &&
    !filters.sort;

    const handlePeriodChange = (period) => {
      const dateFrom = calcDateFromByPeriod(period);

      setFilters((prev) => ({
        ...prev,
        dateFrom,
      }));
    };

  const handleChange = (key, value) => {
    if(key=='type')
      setFilters((prev) => ({ ...prev, [key]: value.ids }));
    else
      setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //console.log(filters);
    onApply(filters); // передаєш у parent компонент

    setIsOpen(false);
  };

  const handleReset = () => {
    const nextFilters = {
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
      search: "",
      type: "",
      sort: "",
    };

    setFilters(nextFilters);
    onApply(nextFilters);
  };

  return (
    <div className="filters">
    <div className="d-md-none mb-2">
      <Button
        variant="outline-secondary"
        className="bar-toggle w-100 btn-sm d-flex justify-content-between align-items-center"
        onClick={() => setIsOpen(p => !p)}
      >
        <span>
          <i className="fa-solid fa-filter me-2"></i>
          Filters
        </span>
        <i className={`fa-solid fa-angle-${isOpen ? 'up' : 'down'}`}></i>
      </Button>
    </div>

    <Form
      onSubmit={handleSubmit}
      className={`filter-bar gap-2 align-items-start mb-3 p-3
        ${isOpen ? 'd-block' : 'd-none'}
        d-md-flex
      `}
    >

      <div className="form-group d-flex gap-2">

      {visibleFilters.includes("search") && (
        <Form.Control
          type="text"
          placeholder="Search SKU, Title, ASIN, FNSKU"
          value={filters.search}
          onChange={(e) => handleChange("search", e.target.value)}
          className="form-search mb-2 mb-md-0"
        />
      )}

      {visibleFilters.includes("type") && (
        <TypeTreeDropdown
          selectedType={filters.type}
          onChange={(val) => handleChange("type", val)}
        />
      )}

      </div>

      {visibleFilters.includes("date") && (
        <div className="form-period d-flex gap-2 mb-2 mb-md-0">
          {/* dateFrom */}
          <Form.Control
            size="sm"
            type="date"
            value={filters.dateFrom}
            onChange={(e) => handleChange("dateFrom", e.target.value)}
          />

          {/* period */}
          <Dropdown onSelect={(val) => handlePeriodChange(val)}>
            <Dropdown.Toggle variant="light">
              Period
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item eventKey="6m">6 month</Dropdown.Item>
              <Dropdown.Item eventKey="1y">Year</Dropdown.Item>
              <Dropdown.Item eventKey="18m">18 month</Dropdown.Item>
              <Dropdown.Item eventKey="2y">2 year</Dropdown.Item>
              <Dropdown.Item eventKey="3y">3 year</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* dateTo */}
          <Form.Control
            size="sm"
            type="date"
            value={filters.dateTo}
            onChange={(e) => handleChange("dateTo", e.target.value)}
          />
        </div>
      )}

      {visibleFilters.includes("sort") && (
        <Dropdown onSelect={(val) => handleChange("sort", val)} className="d-inline me-2 me-md-0">
          <Dropdown.Toggle variant="light">
            {filters.sort || "Sort"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item eventKey="sales_desc">Sales ↓</Dropdown.Item>
            <Dropdown.Item eventKey="sales_asc">Sales ↑</Dropdown.Item>
            <Dropdown.Item eventKey="price_desc">Price ↓</Dropdown.Item>
            <Dropdown.Item eventKey="price_asc">Price ↑</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}

      <Button variant="primary" type="submit" className="me-2 me-md-0">
        <i className="fa-solid fa-magnifying-glass"></i> search
      </Button>

      <Button variant="outline-secondary" type="button"
        onClick={handleReset}
        disabled={isFiltersClean()}>
        Reset
      </Button>

    </Form>
    </div>
  );
};

export default FilterBar;
